import actions from '../../constants/actionTypes';

const initialState = {
  isFetching: false,
  errorMessage: '',
  confirmPassword: false,
};

function loginReducer(state = initialState, action) {
  const { type } = action;
  switch (type) {
    case actions.REQUEST_LOGIN: {
      return {
        ...state,
        isFetching: true,
      };
    }

    case actions.CONFIRM_PASSWORD_SUCCESSFULLY: {
      let confirmPassword = false;
      const { response } = action;
      const { confirm_password_code } = response.reply;
      if (confirm_password_code) {
        confirmPassword = true;
      }
      return {
        ...state,
        isFetching: false,
        confirmPassword,
      };
    }

    case actions.CONFIRM_PASSWORD_ERROR: {
      return {
        ...state,
        isFetching: false,
        errorMessage: action.response.result,
      };
    }

    case actions.CONFIRM_PASSWORD_CLEAR: {
      return {
        ...state,
        confirmPassword: false,
        errorMessage: '',
      };
    }

    default: {
      return state;
    }
  }
}

export default loginReducer;



// WEBPACK FOOTER //
// ./foody/src/pages/Login/reducers.jsx